import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const res = await login(form.email, form.password);
    setBusy(false);
    if (!res.ok) { setErr(res.error); return; }
    toast.success("Welcome back");
    navigate(next);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="overline text-[var(--fm-accent)]">Sign in</div>
      <h1 className="font-display text-4xl mt-2">Welcome to White Molar.</h1>
      <p className="text-sm text-[var(--fm-text-2)] mt-2">Access your orders, enquiries and saved clinics.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <Field label="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="login-email" required />
        <Field label="Password" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="login-password" required />
        {err && <div data-testid="login-error" className="text-sm text-red-600">{err}</div>}
        <button type="submit" disabled={busy} data-testid="login-submit" className="fm-btn-primary w-full">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
      <div className="text-sm text-[var(--fm-text-2)] mt-6">
        New to White Molar?{" "}
        <Link to={`/register${next !== "/" ? `?next=${encodeURIComponent(next)}` : ""}`} className="text-[var(--fm-primary)] underline underline-offset-4">Open an account</Link>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", testid, required }) {
  return (
    <div>
      <label className="overline">{label}</label>
      <input required={required} type={type} value={value} data-testid={testid} onChange={(e) => onChange(e.target.value)} className="w-full border border-[var(--fm-border)] mt-2 px-3 py-2.5 text-sm bg-white focus:outline-none focus:border-[var(--fm-primary)]" />
    </div>
  );
}
